// Models
import { createUserAccessStoreDefaultModel } from './user-access/user-access.store'

const userAccessModels = {
  userAccess: createUserAccessStoreDefaultModel(),
}

export { userAccessModels }
